function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#647083",
    d: "M 3.5,0.5 C 6.5,0.5 9.5,0.5 12.5,0.5C 12.1667,5.5 14.5,7.83333 19.5,7.5C 19.5,12.5 19.5,17.5 19.5,22.5C 14.1667,22.5 8.83333,22.5 3.5,22.5C 3.5,15.1667 3.5,7.83333 3.5,0.5 Z M 11.5,10.5 C 16.4277,11.8915 16.5944,13.5582 12,15.5C 10.9025,14.0325 9.40246,13.1992 7.5,13C 9.437,12.8784 10.7703,12.045 11.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.869
    },
    fill: "#657083",
    d: "M 14.5,0.5 C 20.7035,3.1094 20.7035,4.77607 14.5,5.5C 14.5,3.83333 14.5,2.16667 14.5,0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportDataIcon);
export default __webpack_public_path__ + "static/media/exportDataIcon.646d388414589bd06cc36b78032b257e.svg";
export { ForwardRef as ReactComponent };